import { makeStyles } from "@material-ui/core";

const textStyle = makeStyles((theme) => ({
  // Text
  text1: {
    ...theme.typography.body1,
  },
  text2: {
    ...theme.typography.body2,
    margin: 0,
    padding: 0,
  },
  text3: {
    ...theme.typography.body3,
  },
  text4: {
    ...theme.typography.h1,
  },
  heading2: {
    ...theme.typography.h2,
    fontWeight: 500,
  },
  errorText: {
    color: "#f44336",
    margin: 0,
    marginLeft: `14px`,
    marginRight: `14px`,
  },
  textUpper: {
    textTransform: "uppercase",
  },
  textCapitalize: {
    textTransform: "capitalize",
  },
  textSm: {
    fontSize: 11,
  },
  textMd: {
    fontSize: 12,
  },
  title: {
    ...theme.typography.h2,
    textTransform: "capitalize",
    fontWeight: 700,
  },
  subtitle: {
    ...theme.typography.h3,
    textTransform: "capitalize",
  },

  // Text

  // Header
  header1: {
    ...theme.typography.h1,
    ...theme.typography.semiBold,
    display: "block",
  },
  header2: {
    ...theme.typography.h2,
    ...theme.typography.semiBold,
    display: "block",
  },
  header3: {
    ...theme.typography.h3,
    ...theme.typography.semiBold,
    display: "block",
  },
  headerWrap: {
    ...theme.borderBottom,
    paddingBottom: 12,
    marginBottom: 12,
  },
  headerLG: {
    ...theme.typography.hlg,
    ...theme.typography.semiBold,
  },
  headerXL: {
    ...theme.typography.hxl,
    ...theme.typography.semiBold,
    "@media (max-width: 768px)": {
      fontSize: "1rem",
    },
  },
  // Modal
  modalHeader: {
    ...theme.typography.h2,
    ...theme.typography.semiBold,
    textTransform: "capitalize",
  },
  modalHeadWrap: {
    padding: "4px 16px",
    ...theme.borderBottom,
  },

  // Table
  tableLable: {
    ...theme.typography.body2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "250px",
  },
  tableHeader: {
    ...theme.typography.body2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "250px",
    fontWeight: 800,
  },

  // Form
  lable: {
    ...theme.typography.body1,
    ...theme.typography.semiBold,
    display: "block",
    textTransform: "capitalize",
    paddingBottom: 4,
  },
  value: {
    ...theme.typography.body1,
    textWrap: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  //
  lableMargin: {
    margin: `18px 0px`,
  },
  textMT: {
    marginTop: 18,
  },
  textMB: {
    marginBottom: 18,
  },
  textPT: {
    paddingTop: 8,
  },
  textPB: {
    paddingBottom: 8,
  },
  textMBSm: {
    marginBottom: 4,
  },
  textFaded: {
    color: "#A4AFBD",
    margin: 0,
  },
  textFadedDark: {
    color: "#545b64",
  },
  textPrimary: {
    color: theme.palette.primary.main,
  },
  textSecondary: {
    color: theme.palette.secondary.main,
  },
  infoText: {
    color: "#6e6c6c",
    ...theme.typography.body2,
    fontStyle: "italic",
    marginTop: "12px",
    textAlign: "right",
  },
  clearLink: {
    textDecoration: "none",
    color: "inherit",
  },

  // Weight
  normal: {
    fontWeight: 500,
  },
  bold: {
    ...theme.typography.bold,
  },
  semibold: {
    ...theme.typography.semiBold,
  },
  pointer: {
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },

  //
  alignRight: {
    textAlign: "right",
  },
  alignCenter: {
    textAlign: "center",
  },

  //
  textWhite: {
    color: "#fff",
  },
  emptyState: {
    color: theme.palette.text.secondary,
    fontSize: "0.85rem",
    fontStyle: "italic",
  },
}));

export default textStyle;
